// extracted by mini-css-extract-plugin
export default {"skuItem":"src-pages-Order-Components-SkuItems-css-module__skuItem--TTKOe"};